import {CompositionReviewDetail} from '@letrustech/letrus-api-interfaces/dist/interfaces/letrus_api';
import prof_1x from 'assets/images/characters/teacher/teacher.webp';
import {Accordeon} from 'letrus-ui';
import {DevolutiveCard} from 'components/ui';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {getLearningPath} from 'store/reducers/learningPath';
import {ApplicationState} from 'store/rootReducer';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import {EventData} from 'utils/hooks/useTrackEvent/types';
import {CompositionDetailExtended} from 'utils/types/compositions';
import {LearningPathTemp} from 'utils/types/learningPath';
import {MappedCompetences} from '..';
import styles from './Competences.module.scss';

interface OwnProps {
  review: ImmutableMap<CompositionReviewDetail>;
  competences: MappedCompetences[];
  composition?: ImmutableMap<CompositionDetailExtended>;
  expand?: boolean;
}

interface StateProps {
  learningPath?: LearningPathTemp;
}

export type Props = OwnProps & StateProps;

const Competences: React.FC<Props> = ({
  review,
  competences,
  composition,
  learningPath,
  expand,
}) => {
  const [generalComments, setGeneralComments] = useState<string>('');
  const {trackEvent} = useTrackEvent();
  const eventData: EventData = {
    composition: {
      composition_id: Number(composition?.get('id')) ?? 0,
    },

    ...(learningPath
      ? {
          learningPathUserInstance: {
            learning_path_user_instance_id: learningPath?.id ?? 0,
            step_id:
              learningPath.steps?.find(
                (step) => step.order === learningPath.step_number,
              )?.id || 0,
          },
        }
      : {}),
    test: {
      test_id: Number(composition?.getIn(['test', 'id'])),
    },
    review: {
      review_id: Number(review?.get('id') ?? 0),
    },
  };

  useEffect(() => {
    if (review.size) {
      setGeneralComments(review.get('general_comments'));
    }
  }, []);

  return (
    <>
      <div className={`${styles.competence} ${expand ? styles.noMargin : ''}`}>
        <Accordeon
          items={[
            {
              content: (
                <div>
                  {!!generalComments && (
                    <div className={styles.comment}>
                      <div className={styles.icon}>
                        <img src={prof_1x} alt="Professor" />
                      </div>

                      <DevolutiveCard>
                        <div
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: generalComments,
                          }}
                        />
                      </DevolutiveCard>
                    </div>
                  )}
                </div>
              ),
              titleLeft: (
                <div className={styles.name} title="Comentários gerais">
                  Comentários gerais
                </div>
              ),
            },
            ...competences.map((competence: MappedCompetences) => {
              return {
                content: (
                  <div className={styles.competence}>
                    <div>{competence.description}</div>
                    {!!competence.comments && (
                      <div className={styles.comment}>
                        <div className={styles.icon}>
                          <img src={prof_1x} alt="Professor" />
                        </div>

                        <DevolutiveCard>
                          <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                              __html: competence.comments,
                            }}
                          />
                        </DevolutiveCard>
                      </div>
                    )}
                  </div>
                ),
                titleLeft: (
                  <div className={styles.name} title={competence.name}>
                    {competence.name}
                  </div>
                ),
                titleRight: (
                  <div className={styles.score} title={competence.scoreDisplay}>
                    {competence.scoreDisplay}
                  </div>
                ),
              };
            }),
          ]}
          onItemClick={(index: number) => {
            const competences = composition
              ?.getIn(['genre', 'competences'])
              ?.toJS();

            /*  ignoring the first position of the array because it is a general comment */
            const competenceId = competences?.[index - 1]?.id ?? 0;

            trackEvent('has_uncollapsed_review_item', {
              ...eventData,
              competence: {
                competence_id: competenceId,
              },
            });
          }}
        />
      </div>
    </>
  );
};

export default connect((state: ApplicationState) => ({
  learningPath: getLearningPath(state),
}))(Competences);
